import { PagedCollectionParams } from './paged-collection-params';

/**
 * Class used to handle paginated requests for Users from Accounts API
 */
export class UserPagedCollectionParams extends PagedCollectionParams {
  userStatus: '' | 'All' | 'Invited' | 'Uninvited';
  productId: null | number;
  productLastActiveStatus: '' | 'Active' | 'All' | 'NotActive';
  copilotVersion: null | string = null;
  mapDataVersion: null | string = null;
  assignedOnly: boolean | null = null;
  lastActiveDateFilter: null | string = null;
  assetFilter = 0;
  assetFilterReferenceDate: null | string = null;

  constructor(params: {
    assetFilterReferenceDate?: string;
    assignedOnly?: boolean;
    copilotVersion?: string;
    lastActiveDateFilter?: string;
    limit: number;
    mapDataVersion?: string;
    offset: number;
    productId?: number;
    productLastActiveStatus?: '' | 'Active' | 'All' | 'NotActive';
    query?: string;
    sortDirection?: '' | 'asc' | 'desc';
    sortExpression?: string;
    userStatus?: '' | 'All' | 'Invited' | 'Uninvited';
  }) {
    super(params);

    this.productLastActiveStatus = params.productLastActiveStatus ?? '';
    this.userStatus = params.userStatus ?? '';
    this.productId = params.productId ?? null;
    this.copilotVersion = params.copilotVersion ?? null;
    this.mapDataVersion = params.mapDataVersion ?? null;
    this.assignedOnly = params.assignedOnly ?? null;
    this.lastActiveDateFilter = params.lastActiveDateFilter ?? null;
    this.assetFilterReferenceDate = params.assetFilterReferenceDate ?? null;
  }

  private generateUserParams() {
    const params = this.generateParams();

    if (this.userStatus) {
      params.append('userStatus', this.userStatus);
    }

    if (this.productLastActiveStatus) {
      params.append('productLastActiveStatus', this.productLastActiveStatus);
    }

    if (typeof this.productId === 'number') {
      params.append('productId', String(this.productId));
    }

    if (typeof this.copilotVersion === 'string') {
      params.append('copilotVersion', this.copilotVersion);
    }

    if (typeof this.mapDataVersion === 'string') {
      params.append('query', this.mapDataVersion);
    }

    if (this.assignedOnly !== null) {
      params.append('assignedOnly', String(this.assignedOnly));
    }

    if (this.lastActiveDateFilter !== null) {
      params.append('lastActiveDateFilter', this.lastActiveDateFilter);
    }

    if (this.assetFilterReferenceDate !== null) {
      params.append('assetFilter', String(this.assetFilter));
      params.append('assetFilterReferenceDate', this.assetFilterReferenceDate);
    }

    return params;
  }

  /**
   * Returns string properly formatted for URL paramters
   */
  override get urlParams() {
    const params = this.generateUserParams();

    return params.toString();
  }
}
